/**
 * Initial Content Plugin for Lexical Editor
 * Loads existing HTML content when editor initializes
 */
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $generateNodesFromDOM } from '@lexical/html';
import { $getRoot, $insertNodes } from 'lexical';
import { useEffect, useState } from 'react';

function useSafeLexicalComposerContext() {
    try {
        return useLexicalComposerContext();
    } catch (e) {
        console.warn('LexicalComposerContext not found in InitialContentPlugin:', e);
        return [null];
    }
}

export default function InitialContentPlugin({ initialHtml }) {
    const [editor] = useSafeLexicalComposerContext();
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if (!editor || !initialHtml || initialized) {
            return;
        }

        editor.update(() => {
            try {
                const parser = new DOMParser();
                const dom = parser.parseFromString(initialHtml, 'text/html');
                const nodes = $generateNodesFromDOM(editor, dom);
                const root = $getRoot();
                root.clear();
                $insertNodes(nodes);
            } catch (e) {
                console.warn('Failed to parse initial HTML:', e);
            }
        });

        setInitialized(true);
    }, [editor, initialHtml, initialized]);

    return null;
}
